<template>
  <DatatableV3
    id="communications-change-history-table"
    ref="table"
    :config="config"
    :source="source"
  />
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import DatatableV3 from "@/components/DatatableV3.vue";

defineProps({
  source: {
    type: String,
    required: true
  }
});

const config = {
  lengthChange: true,
  pageLength: 10,
  order: [[0, "desc"]],
  columns: [
    { data: "datetime", title: "Date & Time", orderable: true },
    { data: "updates", title: "Changes", orderable: false },
    { data: "admin", title: "Changed By", orderable: true },
    { data: "reason", title: "Reason for change", className: "reason-column" }
  ]
};

const table = ref(null);

function refresh() {
  //@ts-expect-error no component type
  table.value?.refreshData();
}

defineExpose({ refresh });
</script>

<style lang="scss">
table#communications-change-history-table {
  .reason-column {
    max-width: 500px;
    white-space: normal;
  }
}
</style>
